export default __webpack_public_path__ + "static/media/cek-nopen.8ffd551d.webp";